<template>
  <div class="edit-content my-5">
    <div class="container">
      <div class="row mb-3">
        <div class="col-auto">
          <div class="form-group">
            <fieldset>
              <select name="selectedEvent" class="form-control" v-model="selectedEvent">
                <option :value="null">Select event</option>
                <option :value="event.id" v-for="event in events" :key="`eventSelect-${event.id}`">{{ event.header }}</option>
              </select>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="row" v-if="selectedEvent">
        <div class="col-12">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Namn</th>
                <th>Fråga</th>
                <th>Inskickad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredQuestions.length == 0">
                <td colspan="3" class="text-center">No questions found. :(</td>
              </tr>
              <tr v-for="question in filteredQuestions" :key="question.id">
                <td>{{ question.name }}</td>
                <td>{{ question.question }}</td>
                <td>{{ $DateTime.fromJSDate(question.created.toDate(), { locale: "sv-SE" }).toLocaleString($DateTime.DATETIME_SHORT_WITH_SECONDS) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "questions",
    beforeRouteEnter(to, from, next) {
      if(to.query.showme) {
        next()
      } else {
        next({ name: "home" })
      }
    },
    data() {
      return {
        loading: true,
        selectedEvent: null,
        events: [],
        questions: []
      }
    },
    computed: {
      filteredQuestions() {
        if(this.selectedEvent) {
          return this.questions.filter((question) => question.eventId == this.selectedEvent)
        } else {
          return []
        }
      }
    },
    async mounted() {
      await this.$bind("events", firebase.firestore().collection(`events`).orderBy("eventStart"))
      await this.$bind("questions", firebase.firestore().collection(`questions`).orderBy("created", "asc"))
    }
  }
</script>